module.exports = __webpack_public_path__ + "static/media/miles.6b93ba07.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/miles.jpg
// module id = 376
// module chunks = 16